export default __webpack_public_path__ + "b3c440d9322bc3beab415ff820487810.svg";